const TableForPolicy = () => {
  return (
    <div className="container p-2 mx-auto sm:p-4 dark:text-gray-800">
      <div className="flex flex-col overflow-x-auto text-xs">
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">Data</p>
          </div>
          <div className="flex-1 block px-2 py-3  sm:p-3 sm:w-auto text-sm">
            collectively all information that you submit to Atendi Ltd. via the
            Website. This definition incorporates, where applicable, the
            definitions provided in the Data Protection Laws;
          </div>
        </div>
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">Cookies</p>
          </div>
          <div className="flex-1 block px-2 py-3  sm:p-3 sm:w-auto text-sm">
            a small text file placed on your computer by this Website when you
            visit certain parts of the Website and/or when you use certain
            features of the Website. Details of the cookies used by this Website
            are set out in the clause below (Cookies);
          </div>
        </div>
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">Data Protection Laws</p>
          </div>
          <div className="flex-1 block px-2 py-3  sm:p-3 sm:w-auto text-sm">
            any applicable law relating to the processing of personal Data,
            including but not limited to the GDPR, and any national implementing
            and supplementary laws, regulations and secondary legislation;
          </div>
        </div>
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">GDPR</p>
          </div>
          <div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto text-sm">
            the UK General Data Protection Regulation;
          </div>
        </div>
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">Atendi Ltd., we or us</p>
          </div>
          <div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto text-sm">
            Atendi Ltd., a company incorporated in England and Wales with
            registered number 14185160 whose registered office is at 150
            Midsummer Boulevard, Milton Keynes, MK9 1FD;
          </div>
        </div>
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">UK and EU Cookie Law</p>
          </div>
          <div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto text-sm">
            the Privacy and Electronic Communications (EC Directive) Regulations
            2003 as amended by the Privacy and Electronic Communications (EC
            Directive) (Amendment) Regulations 2011 & the Privacy and Electronic
            Communications (EC Directive) (Amendment) Regulations 2018;
          </div>
        </div>
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">User or you</p>
          </div>
          <div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto text-sm">
            any third party that accesses the Website and is not either (i)
            employed by Atendi Ltd. and acting in the course of their employment
            or (ii) engaged as a consultant or otherwise providing services to
            Atendi Ltd. and accessing the Website in connection with the
            provision of such services; and
          </div>
        </div>
        <div className="flex border-b border-opacity-20 dark:border-gray-300 dark:bg-gray-50">
          <div className="w-32 px-2 py-3 sm:p-3">
            <p className="text-lg">Website</p>
          </div>
          <div className="flex-1 block px-2 py-3 truncate sm:p-3 sm:w-auto text-sm">
            the website that you are currently using, www.motickets.co.uk, and
            any sub-domains of this site unless expressly excluded by their own
            terms and conditions.{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableForPolicy;
